module.exports = __webpack_public_path__ + "static/scale-model-of-thunderhawk-in-allentown-pennsylvania-bac99bb82f4bd79da7e46b5a6c959765.png";